import React from "react";
import { Terminal } from "lucide-react";

const RULES = [
    {
        code: "RULE_01",
        title: "Sem RDM / VDM",
        desc: "Mata sem motivo? Atropela random? Banido. Aqui é RP, não COD.",
    },
    {
        code: "RULE_02",
        title: "Valorize a vida",
        desc: "Sob mira, tu coopera. Não age de herói com 12 canos na cara.",
    },
    {
        code: "RULE_03",
        title: "Microfone obrigatório",
        desc: "Comunicação no jogo. Discord é pra crew, in-game é Voice Chat.",
    },
    {
        code: "RULE_04",
        title: "Sem combat log",
        desc: "Deslogou no tiroteio? Punição na conta. Bandido aceita o destino.",
    },
    {
        code: "RULE_05",
        title: "Respeito > Tudo",
        desc: "Toxicidade fora de RP = punição. Aqui se constrói história, não inimizade.",
    },
];

export default function Rules() {
    return (
        <section
            id="regras"
            data-testid="rules-section"
            className="relative py-24 md:py-40 bg-[#0a0a0a] border-y border-white/5"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="h-px w-12 bg-neon-yellow" />
                            <span className="font-mono text-xs uppercase tracking-[0.3em] text-neon-yellow">
                                ▸ Codigo de rua
                            </span>
                        </div>
                        <h2 className="font-heading text-5xl md:text-7xl uppercase tracking-tighter leading-none mb-6">
                            Regras<br />
                            <span className="text-neon-yellow">.exe</span>
                        </h2>
                        <p className="text-white/60 text-base leading-relaxed mb-6">
                            Cinco mandamentos. Quebra um, perdeu o jogo. Aqui a
                            staff não brinca em serviço.
                        </p>
                        <div className="font-mono text-xs text-white/40 leading-relaxed">
                            <div>$ &gt; ler_regras --full</div>
                            <div>OK · 5 regras carregadas</div>
                            <div className="text-neon-yellow">
                                $ &gt; bind_status: ENFORCED
                                <span className="caret">█</span>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-8">
                        <div className="bg-[#0d0d0d] border border-white/10">
                            {/* Terminal header */}
                            <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 bg-black">
                                <div className="flex items-center gap-2">
                                    <Terminal size={14} className="text-neon-yellow" />
                                    <span className="font-mono text-xs text-white/60">
                                        /etc/forza/rules.cfg
                                    </span>
                                </div>
                                <div className="flex gap-2">
                                    <span className="w-2.5 h-2.5 bg-neon-red rounded-full" />
                                    <span className="w-2.5 h-2.5 bg-neon-yellow rounded-full" />
                                    <span className="w-2.5 h-2.5 bg-white/40 rounded-full" />
                                </div>
                            </div>

                            <ul className="divide-y divide-white/5">
                                {RULES.map((r, i) => (
                                    <li
                                        key={i}
                                        data-testid={`rule-item-${i}`}
                                        className="group grid grid-cols-12 gap-4 px-5 md:px-8 py-6 hover:bg-white/[0.02] transition-colors"
                                    >
                                        <div className="col-span-3 md:col-span-2 font-mono text-xs text-neon-yellow pt-1">
                                            [{r.code}]
                                        </div>
                                        <div className="col-span-9 md:col-span-10">
                                            <h3 className="font-heading text-2xl md:text-3xl uppercase tracking-tight mb-1">
                                                {r.title}
                                            </h3>
                                            <p className="text-white/60 text-sm md:text-base">
                                                {r.desc}
                                            </p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
